import React, { useEffect, useState } from 'react';

import axios from 'axios';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setSnackbar } from 'modules/snackbar/api/snackbar';
import { List, ListItem, ListItemText, ListItemAvatar, Avatar, Grid, CardContent, Card, Box, Button, Typography, TextField } from '@mui/material';
import { formatWorkOrderAddress } from '../utils/formatWorkOrderAddress';


export default function WorkOrderNotes(props) {
  const dispatch = useDispatch();

  const [notes, setNotes] = useState([])
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")) || {})
  const [add, setAdd] = useState(false);
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(true);
  const toggleAdd = () => {
    setAdd(!add);
  }

  const handleChange = (evt, newValue) => {
    let value = evt.target.value;
    setNote(value);
  };

  const addNote = async () => {

    if (note == "" || !props.workOrder?.id)
      return

    let body = {
      workOrderId: props.workOrder.id,
      note: note
    }

    try {
      let response = await axios.post(`/workordernote`, body)
      if (response.status == 200) {
        setAdd(false);
        setNote("");
        fetchWorkOrderNotes()
      }
      else {
        dispatch(setSnackbar(true, "error", `Failed to create note.`))
      }
    }
    catch (e) {
      dispatch(setSnackbar(true, "error", `Failed to create note.`))
    }
  }

  async function fetchWorkOrderNotes() {
    if (!props.workOrder?.id) return;

    try {
      setLoading(true);
      let response = await axios.get(`/workordernote/workorder/${props.workOrder.id}`)
      if (response.status == 200)
        setNotes(response.data);
    }
    catch {
      dispatch(setSnackbar(true, "error", `Failed to fetch notes.`))
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (props.workOrder?.id) {
      fetchWorkOrderNotes()
    }
  }, [props.workOrder?.id])

  if (!props.workOrder) {
    return <div>Loading work order...</div>;
  }

  return (
    <Card sx={{ marginTop: 2 }}>
      <CardContent>
        <Typography variant="h6">Work Order ID: {props.workOrder?.id || "Loading..."}</Typography>
        <Typography variant="h6">Title: {props.workOrder?.workOrderTitle || "Loading..."}</Typography>
        {props.workOrder?.name != null && props.workOrder.name !== "" && (
          <Typography variant="body1">Property: {props.workOrder.name}</Typography>
        )}
        <Typography variant="body1">
          Address: {formatWorkOrderAddress(props.workOrder) || "N/A"}
        </Typography>
        {notes && notes.length > 0 && (
          <Box marginTop={2}>
            <Typography variant="h6">Notes ({notes.length})</Typography>
            {notes.map((note, index) => (
              <List>
                <ListItem key={note.id} divider>
                  <ListItemAvatar>
                    <Avatar>
                      {note.submittedBy.charAt(0)}
                    </Avatar>
                  </ListItemAvatar>
                  <Grid container flexDirection="column">

                    <Grid item xs={12}>
                    </Grid>
                    <Grid item xs={12}>
                      <ListItemText primary={note.submittedBy} />
                      <ListItemText primary={"Created: " + moment(note.created).format("L LT")} />
                      <ListItemText primary={"Last updated: " + moment(note.updated).format("L LT")} />
                      <ListItemText secondary={note.note} />
                    </Grid>
                    <Grid item xs={12}>
                    </Grid>
                  </Grid>
                </ListItem>
              </List>
            ))}
          </Box>
        )}
        {loading && <p>Loading notes...</p>}

        {add && (
          <Box>
            <Typography variant="h6">Add New Note</Typography>
            <TextField
              sx={{ my: 2 }}
              multiline
              rows={4}
              value={note}
              onChange={handleChange}
              placeholder="Enter your note here..."
              style={{ width: '100%', height: '100px' }}
            />
            <Box display="flex" justifyContent="flex-end" marginTop={2}>
              <Button onClick={addNote}>Save Note</Button>
              <Button onClick={toggleAdd}>Cancel</Button>
            </Box>
          </Box>
        )}

        {!add && (
          <Box display="flex" justifyContent="flex-end" marginTop={2}>
            <Button onClick={toggleAdd}>Add Note</Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
